<template lang="pug">
#page_content.rule.page
	Banner(v-bind:item='item_banner', classes='half')
	.container.article
		.row.justify-content-center: .col-sm-10
			template(v-if='$i18n.locale === "tw"')
				h2.mb-5 2024台灣國際兒童影展 徵件辦法
				p.content
					| 台灣國際兒童影展（Taiwan International Children’s Film Festival, TICFF）由公共電視於2004年創辦，是亞洲第一個專為兒童所設立的影視節目展。本影展廣邀世界各地適合兒童觀賞的優良劇情片、動畫、電視／網路節目與紀錄片參與國際競賽，以高額獎金鼓勵全球影像工作者製作富有創意、趣味與多元文化視野的作品。第11屆台灣國際兒童影展將於2024年4月在台北盛大舉行，歡迎全球影像工作者踴躍報名參加。
				h3 一、徵件時間：2023年5月1日起至2023年9月8日止。
				h3 二、徵件類別
				ol
					li 適合12歲以下兒童觀賞之節目或影片。
					li 
						| 2021年9月1日至2023年9月8日（報名截止日）之間完成之作品。
						h5.note ※ 報名截止日前未完成之作品、商業廣告恕不受理。

				table.table.table-bordered.table-dark
					thead
						tr
							th(scope='col') 類別
							th(scope='col') 影片長度限制
							th(scope='col') 說明
					tbody
						tr
							td 最佳劇情短片
							td 40分鐘內
							td
						tr
							td 最佳劇情片
							td 40分鐘以上
							td
						tr
							td 最佳動畫短片
							td 40分鐘內
							td(rowspan='2') 動畫內容需達全片75%以上。
						tr
							td 最佳動畫片
							td 40分鐘以上
						tr
							td 最佳電視／網路系列節目
							td 60分鐘內
							td 於電視／網路播放，至少3集之系列節目。提報一集即可。
						tr
							td 最佳紀錄片
							td 100分鐘內
							td

				h3 三、報名方式
				h4 （一）Filmfreeway報名：
				p 請於FilmFreeway平台（https://filmfreeway.com/）建立帳號及作品資料，並至台灣國際兒童影展頁面（https://filmfreeway.com/TICFF）提交作品，完成付費即完成報名。
				p 同一影片僅能擇一類別報名，不得重複報名。作品內容與報名類別不符者將不列入評選，主辦方亦不會另行通知。
				table.table.table-bordered.table-dark
					thead
						tr
							th(scope='col') 徵件類別
							th(scope='col') 早鳥價（7/15前）
							th(scope='col') 一般價（7/16至9/8）
					tbody
						tr
							td 最佳劇情短片
							td US$ 10
							td US$ 20
						tr
							td 最佳劇情片
							td US$ 20
							td US$ 35
						tr
							td 最佳動畫短片
							td US$ 10
							td US$ 20
						tr
							td 最佳動畫片
							td US$ 20
							td US$ 35
						tr
							td 最佳電視/網路系列節目
							td US$ 10
							td US$ 20
						tr
							td 最佳紀錄片
							td US$ 15
							td US$ 25
						tr
							td.note.text-center(colspan='4') 為鼓勵台灣創作，凡影片出品國籍為台灣之作品，免收取報名費。如為台灣作品團隊，或是5件以上大宗報名，<br/>請聯絡 contact@ticff.org.tw 進一步洽詢報名細節。

				h3 四、頒發獎項
				ol
					li 最佳劇情短片
					li 最佳劇情片
					li 最佳動畫短片
					li 最佳動畫片
					li 最佳電視/網路系列節目
					li 最佳紀錄片
					li 台灣獎
					li 評審團特別獎
						p.content 
							| 由評審團評選，各獎項入圍作品至多五部，頒贈入圍證書乙份。各獎項取優勝者1名，頒贈獎金3,500美元與獎座乙座。如任一獎項有兩部作品同時得獎，獎金由獲獎團隊平分。
							br
							| ※ 台灣獎為本影展特別設立之獎項，以鼓勵由台灣在地團隊為台灣兒童創作的影視內容，由評審團自1-6項中的台灣作品選出優勝者。
					li 觀眾票選獎
						p.content 
							| 影展期間由觀眾票選，頒贈獎座乙座。

				h3 五、入圍與得獎公佈
				p.content 完整入圍名單將於2024年1月1日於影展官方網站公布（www.ticff.org.tw），得獎名單則於影展活動後公布。

				h3 六、評審作業
				h4 第一階段 ── 初選
				p.content 由台灣電影、電視及教育界專業人士組成評審團，選出入圍作品。入圍作品將於本屆影展期間進行實體放映。
				h4 第二階段 ── 決選
				p.content 於國內初選評審團外，加邀兩位國際評審，共同組成決選評審團，於2024年4月影展期間召開決選會議，決定得獎名單。若入圍作品無法達到決選之評審標準，主辦方將保留獎項從缺之權利。
				h4 評審項目如下：
				ol
					li 與兒童議題的相關性
					li 提供兒童多元視野、拓展兒童生命體驗
					li 創意內容及創新手法
					li 製作技巧、美學藝術呈現

				h3 七、參賽及入圍影片放映
				p.content 報名單位接獲入選通知後，須於2023年12月15日前繳交以下資料：
				table.table.table-bordered.table-dark
					tbody
						tr
							td 1.
							td 符合商業映演放映標準之DCP、BluRay或HD數位檔
							td 
						tr
							td 2.
							td 完整對白本（英文與原語文版，無對白之作品可免）
							td .srt為佳。
						tr
							td 3.
							td 中文或英文劇情大綱（300字以內）
							td 
						tr
							td 4.
							td 預告片
							td HD之.mov或.mp4。
						tr
							td 5.
							td 影片海報
							td(rowspan='3') 解析度300dpi以上，.jpg、.tif、.png皆可。

						tr
							td 6.
							td 影片劇照5張
						tr
							td 7.
							td 導演個人照1張
						tr
							td 8.
							td 導演的話
							td 300字內。
						tr
							td 9.
							td 完成簽署之參賽同意書
							td .pdf 或圖片檔。空白同意書將隨入圍通知以電子郵件附檔的形式寄出。
				ol
					li 影片拷貝寄送費由入圍者自行負擔。
					li 主辦方有權於影展期間免費實體播映入圍影片3次，並可使用報名者提供之文字資料、劇照、影片預告及片段，於各媒體平台進行公開宣傳，宣傳使用之片長以原影片10分之1或3分鐘為限。此素材可能提供任何第三方作為宣傳之用，不受時間、地區限制。

				h3 八、報名截止後不得退賽，報名視為同意2024台灣國際兒童影展徵件辦法所有規則。

				h3 九、影展辦公室
				p.content
					| 台灣國際兒童影展 (財團法人公共電視文化事業基金會)
					br
					| 電話：02-2633-2000 #8013
					br
					| 地址：114 台北市內湖區康寧路三段 75 巷 50 號 7 樓
					br
					| Email：ticff.ptsoffice@gmail.com
					br
					| 網址：http://www.ticff.org.tw

			//- English
			template(v-else)
				h2.mb-5 2024 Taiwan International Children’s Film Festival (TICFF) Submission Guidelines
				p.content
					| Taiwan International Children’s Film Festival (TICFF) is a biennial event founded by Taiwan Public Television Service (PTS) in 2004, and the first film and television festival in Asia dedicated entirely to children aged 4-12. The 11th edition of TICFF is scheduled for April 2024 in Taipei. We are calling for entries with a cash prize of US$28,000 in total for extraordinary productions of dramas, animations, documentaries, and TV/Web series.
					h4 SUBMISSION PERIOD: May 1-Sep. 8, 2023
					br
				h3 ELIGIBILITY
				ol
					li Submissions must be suitable for children aged 4-12, and completed between Sep. 1, 2021 and Sep. 8, 2023.
					li Only completed works can be submitted, we do not view works-in-progress.
					li We do not accept commercial advertisements.
				table.table.table-bordered.table-dark
					thead
						tr
							th(scope='col') Categories
							th(scope='col') Length
							th(scope='col') note
					tbody
						tr
							td Best Dramatic Short
							td Under 40 min.
							td
						tr
							td Best Dramatic Feature
							td 40 min. or longer
							td
						tr
							td Best Animated Short
							td Under 40 min.
							td(rowspan='2') Animation must figure in no less than 75% of the picture’s running time. Any animation technique is accepted.
						tr
							td Best Animated Feature
							td 40 min. or longer
						tr
							td Best TV/Web Series
							td Under 60 min.
							td Productions should be presented in a series of 3 or more episodes. Please submit only ONE best episode.
						tr
							td Best Documentary
							td Under 100 min.
							td

				h3 Submission: FilmFreeway
				p Complete the registration procedure for your film/episode on the platform, submit your work to https://filmfreeway.com/TICFF and make the payment to finalize the submission.
				h4 Notes:
				ol
					li Every production can only be submitted to ONE category.
					li If the work is eligible for two categories or more, please choose the one you deem most suitable. We do not help change the category of your submission.
					li Submissions with original language other than English or Mandarin Chinese must be subtitled or dubbed into English.
					li Once submitted, entries may not be withdrawn from participation in the festival after the call for entries closes.

				h3 Fees
				table.table.table-bordered.table-dark
					thead
						tr
							th(scope='col') Categories
							th(scope='col') Early bird (before 2023 Jul. 15)
							th(scope='col') Regular (Jul. 16-Sep. 8)
					tbody
						tr
							td Best Dramatic Short
							td US$ 10
							td US$ 20
						tr
							td Best Dramatic Feature
							td US$ 20
							td US$ 35
						tr
							td Best Animated Short
							td US$ 10
							td US$ 20
						tr
							td Best Animated Feature
							td US$ 20
							td US$ 35
						tr
							td Best TV/Web Series
							td US$ 10
							td US$ 20
						tr
							td Best Documentary
							td US$ 15
							td US$ 25

				h3 AWARDS & PRIZES
				h4 IN COMPETITION
				ul
					li Best Dramatic Short
					li Best Dramatic Feature
					li Best Animated Short
					li Best Animated Feature
					li Best TV/Web Series
					li Best Documentary
				p.content One winner per category receives a US$3,500 cash prize and a trophy. Up to 5 finalists per category will be selected by the Jury. Each finalist will receive a nomination certificate.
				h4 OUT OF COMPETITION
				ul
					li Taiwan Award
					li Special Jury Award
					li Audience Award*
				p.content 
					| One winner per category. The winners of the Special Jury Award and Taiwan Award each receive a US$3,500 cash prize and a trophy. Any locally-produced submission from competition categories is eligible for Taiwan Award.
					br
					| *The winner of the Audience Award receives a trophy with no cash prize.
					h4 NOTES:
						| In the event of a tie, the cash prize will be divided equally between the two winners.
					br

				h3 ANNOUNCEMENT OF FINALISTS & WINNERS
				p.content Complete list of finalists will be announced on January 1, 2024 on the TICFF website (www.ticff.org.tw). Winners will be announced after the festival concludes (Apr. 2024).

				h3 JUDGING PROCESS
				h4 Stage 1 – Preliminary Selections
				p.content A panel of judges comprised of domestic professionals from the fields of filmmaking, television production and education will select up to five finalists for each category. Finalist productions will be screened during the festival.
				h4 Stage 2 – Final Selections
				p.content For final selections, the original panel of judges from the preliminary selections will be joined by two international judges. During the festival in April 2024, the panel will convene a meeting to decide the winners. If the finalist productions fail to reach the final selection evaluation criteria, the organizer reserves the right to retain the award.
				h4 Productions will be judged based on the following criteria：
				ol
					li Relevance to children.
					li Effectiveness in developing children’s perspectives and global outlook.
					li Creativity of content and techniques.
					li Production skills and aesthetics.

				h3 SCREENING
				p.content If your entry enters the final round, you irrevocably grant TICFF the right on a no-fee basis to exhibit your entry physically and publicly 3 times within Taiwan during the festival and for a period of 4 weeks thereafter.
				p.content Finalists will be notified by the Festival Office. Upon receiving the notification, the finalist needs do deliver the following: .
				table.table.table-bordered.table-dark
					tbody
						tr
							td 1.
							td Screening copy
							td DCP, Bluray, or HD digital files.
						tr
							td 2.
							td Complete dialogue list
							td in English AND original language, ideally .srt file.
						tr
							td 3.
							td Synopsis
							td Under 300 words
						tr
							td 4.
							td Trailer
							td HD files (mov or mp4)
						tr
							td 5.
							td Poster
							td(rowspan='3') 300dpi or better (.jpg or .tiff)

						tr
							td 6.
							td Stills x5
						tr
							td 7.
							td Director photo x1
						tr
							td 8.
							td Director’s statement
							td Under 300 words
						tr
							td 9.
							td Participation Agreement, signed
							td Agreement will be attached to the finalist notification email.
				p.note.text-center * Participants must bear incoming shipping costs to the Festival.

				h3 By submitting entries, you are agreeing to the 2024 Taiwan International Children’s Film Festival (TICFF) Submission Guidelines.

				h3 FESTIVAL OFFICE
				p.content
					| Taiwan International Children’s Film Festival (Public Television Service Foundation)
					br
					| Tel: +886-2-2633-2000 #8013
					br
					| Fax: +886-2-2630-1895
					br
					| 7F, No. 50, Ln. 75, Sec. 3, Kangning Rd., Neihu Dist., Taipei City 114055
					br
					| Email：ticff.ptsoffice@gmail.com
					br
					| Website: http://www.ticff.org.tw
</template>
<script>
import Banner from '@/components/Banner.vue';
export default {
	data() {
		return {
			item_banner: {
				media: 'assets/images/banner_2.jpg',
				title: this.$t('nav_competition_rule'),
			},
		};
	},
	watch: {
		'$i18n.locale'() {
			this.item_banner.title = this.$t('nav_competition_rule');
		},
	},
	components: {
		Banner,
	},
};
</script>

<style lang="stylus">
#page_content.rule
	.article
		img
			width: 100%
		.note
			color: $color_yellow
		.content
			margin-bottom: 30px
		h3
			margin: 20px 0 20px 0
		h4
			font-weight: 500
		ol
			margin: 1rem 0 2.5rem 0
		table
			margin: 30px 0
			border: #315078
			tbody
				vertical-align: middle
		.table>:not(:first-child)
			border-top: 0
		.table>:not(caption)>*>*
			background-color: rgba(0, 0, 0, 0.4)
</style>
